const ACCOUNT_ENTITY = 'org';
const CONTACT_ENTITY = 'person';

const STATUS = {
    QA_REVIEW: {
        value: 1,
        key: 'QA Review'
    },
    MANAGER_REVIEW: {
        value: 2,
        key: 'Manager Review'
    },
    NEEDS_FIXED: {
        value: 3,
        key: 'Needs Fixing'
    },
    REJECTED: {
        value: 4,
        key: 'Rejected by Manager'
    },
    FINALIZED: {
        value: 5,
        key: 'Finalized (Client Facing)'
    },
    BAD_LEAD: {
        value: 6,
        key: 'Bad Lead'
    },
    NEEDS_ENRICHMENT: {
        value: 7,
        key: 'Needs Enrichment'
    },
    UNABLE_TO_ENRICH: {
        value: 8,
        key: 'Unable to Enrich'
    },
    CANCELLED: {
        value: 10,
        key: 'Cancelled'
    },
};

const FIELDS = {
    NUM_EMPLOYEES_EXACT: {
        key: 'num_employees_exact',
        caption: 'Employees',
    },
    NUM_EMPLOYEES: {
        key: 'num_employees',
        caption: 'Employee Range',
    },
    ESTIMATED_REVENUE: {
        key: 'estimated_revenue',
        caption: 'Estimated Revenue',
    },
    ANNUAL_REVENUE: {
        key: 'annual_revenue',
        caption: 'Revenue Range',
    },
    STATUS: {
        key: 'status',
        caption: 'Status',
    },
    ENRICHMENT_STATUS: {
        key: 'enrichment_status',
        caption: 'Reason for not Enriching',
    },
    COMPANY_NAME: {
        key: 'company_name',
        caption: 'Company Name',
    },
    PHONE: {
        key: 'phone',
        caption: 'Phone',
    },
    ZIP_CODE: {
        key: 'zip_code',
        caption: 'Zip Code',
    },
    COUNTRY: {
        key: 'country',
        caption: 'Country',
    },
    STATE: {
        key: 'state',
        caption: 'State',
    },
    CITY: {
        key: 'city',
        caption: 'City',
    },
    STREET: {
        key: 'street',
        caption: 'Street',
    },
    EMAIL: {
        key: 'email',
        caption: 'Email',
    },
    INDUSTRY: {
        key: 'industry',
        caption: 'Industry',
    },
    WEBSITE: {
        key: 'website',
        caption: 'Website',
    },
    LAST_NAME: {
        key: 'last_name',
        caption: 'Last Name',
    },
    FIRST_NAME: {
        key: 'first_name',
        caption: 'First Name',
    },
    DEPARTMENT: {
        key: 'department',
        caption: 'Department',
    },
    JOB_TITLE: {
        key: 'job_title',
        caption: 'Job Title',
    },
    SENIORITY: {
        key: 'seniority',
        caption: 'Seniority',
    },
    LINKEDIN_URL: {
        key: 'linkedin_url',
        caption: 'LinkedIn Url',
    },
};

const EXCLUSION_FIELDS = [
    {
        name: FIELDS.COMPANY_NAME.caption,
        key: FIELDS.COMPANY_NAME.key,
        entity: ACCOUNT_ENTITY,
        exclusion: true,
    },
    {
        name: FIELDS.WEBSITE.caption,
        key: FIELDS.WEBSITE.key,
        entity: ACCOUNT_ENTITY,
        exclusion: true,
    },
    {
        name: FIELDS.COUNTRY.caption,
        key: FIELDS.COUNTRY.key,
        entity: ACCOUNT_ENTITY,
        exclusion: true,
    },
    {
        name: FIELDS.STATE.caption,
        key: FIELDS.STATE.key,
        entity: ACCOUNT_ENTITY,
        exclusion: true,
    },
    {
        name: FIELDS.CITY.caption,
        key: FIELDS.CITY.key,
        entity: ACCOUNT_ENTITY,
        exclusion: true,
    },
    {
        name: FIELDS.STREET.caption,
        key: FIELDS.STREET.key,
        entity: ACCOUNT_ENTITY,
        exclusion: true,
    },
    {
        name: FIELDS.ZIP_CODE.caption,
        key: FIELDS.ZIP_CODE.key,
        entity: ACCOUNT_ENTITY,
        exclusion: true,
    },
    {
        name: FIELDS.LINKEDIN_URL.caption,
        key: FIELDS.LINKEDIN_URL.key,
        entity: ACCOUNT_ENTITY,
        exclusion: true,
    },

    {
        name: FIELDS.EMAIL.caption,
        key: FIELDS.EMAIL.key,
        entity: CONTACT_ENTITY,
        exclusion: true,
    },
    {
        name: FIELDS.LAST_NAME.caption,
        key: FIELDS.LAST_NAME.key,
        entity: CONTACT_ENTITY,
        exclusion: true,
    },
    {
        name: FIELDS.FIRST_NAME.caption,
        key: FIELDS.FIRST_NAME.key,
        entity: CONTACT_ENTITY,
        exclusion: true,
    },
    {
        name: FIELDS.JOB_TITLE.caption,
        key: FIELDS.JOB_TITLE.key,
        entity: CONTACT_ENTITY,
        exclusion: true,
    },
    {
        name: FIELDS.LINKEDIN_URL.caption,
        key: FIELDS.LINKEDIN_URL.key,
        entity: CONTACT_ENTITY,
        exclusion: true,
    },

];

export default Object.freeze({
    // NOTIE ALERTS TIMING
    ALERT_TIMES: {
        TINY: 1,  // in seconds
        SMALL: 3,  // in seconds
        MEDIUM: 5,  // in seconds
        LARGE: 8,  // in seconds
    },
    POLLING_STATUSES: {
        OK: 'OK',
        ERRED: 'ERRED',
        SCHEDULED: 'SCHEDULED',
        IN_PROGRESS: 'IN_PROGRESS',
        CANCELLED: 'CANCELLED'
    },
    CONTACT_ENTITY,
    ACCOUNT_ENTITY,
    EXCLUSION_FIELDS,
    ENRICHMENT: {
        METHOD: {
            FILE: 'file',
            REPORT: 'report'
        },
        TYPE: {
            CONTACT: 'person',
            ACCOUNT: 'org'
        },
        MAPPING_TYPE: {
            ALWAYS_UPDATE: {
                key: 'update_always',
                caption: 'Always Update'
            },
            UPDATE_IF_EMPTY: {
                key: 'update_blank',
                caption: 'Update if Empty'
            },
            UPDATE_NEVER: {
                key: 'update_never',
                caption: 'Update Never'
            }
        },
    },
    // Postfixes should be modified simultaneously with backend
    FIELDS: FIELDS,
    STATUS,
    STATUS_CHOICES: [
        STATUS.QA_REVIEW,
        STATUS.MANAGER_REVIEW,
        STATUS.NEEDS_FIXED,
        STATUS.REJECTED,
        STATUS.FINALIZED,
        STATUS.BAD_LEAD,
        STATUS.NEEDS_ENRICHMENT,
        STATUS.UNABLE_TO_ENRICH,
        STATUS.CANCELLED,
    ],
    FORMS: {
        STATUS_FIELDS: ['status', 'enrichment_status'],
        STATE_CHOICES_COUNTRIES: ['us', 'usa', 'united states'],
        INDUSTRY_CHOICES_CACHE: 'industry-choices',
    },
    EXCLUSIONS: {
        ACCOUNT_BIZGRAPH_SEARCH_KEYS: ['company_name'],
        CONTACT_BIZGRAPH_SEARCH_KEYS: ['last_name', 'email'],
        MIN_BIZGRAPH_SEARCH_LENGTH: 3,
        MIN_BIZGRAPH_UNLOCK_LENGTH: 1,
    },
    DUPLICATES_MESSAGES: [
        {min: 0, max: 10, text: 'This is likely not a duplicate.', classes: 'alert-success'},
        {min: 10, max: 70, text: 'This could be a duplicate.', classes: 'alert-warning'},
        {min: 70, max: 100, text: 'This is likely a duplicate.', classes: 'alert-danger'},
    ],
});
